<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <div>
                  <b-table striped small bordered hover :items="columns"  thead-class="hidden_header"></b-table>
                </div>
              </b-col>
            </b-row>
            <!-- <b-row>
                <b-col lg="12" sm="12">
                    <b-form-group label-cols-sm="3" :label="$t('org_pro.organization')">
                      <b-form-input v-model="circulateNotices.org_name"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-sm="3" :label="$t('notification.notice_title')">
                        <b-form-input v-model="circulateNotices.notice_title" readonly></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-sm="3" :label="$t('notification.notice_description')">
                        <b-form-input v-model="circulateNotices.description" readonly></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-sm="3" :label="$t('org_pro.office_name')">
                        <b-form-input v-model="circulateNotices.office_name" readonly></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-sm="3" :label="$t('globalTrans.designation')">
                        <b-form-input v-model="circulateNotices.designation" readonly></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-sm="3" :label="$t('globalTrans.date')">
                        <b-form-input v-model="circulateNotices.notice_date" readonly></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-sm="3" :label="$t('globalTrans.time')">
                        <b-form-input v-model="circulateNotices.notice_time" readonly></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row> -->
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'

export default {
  props: ['id', 'circulateNoticeDetailsData'],
  components: {
  },
  created () {
      this.circulateNotices = this.circulateNoticeDetailsData
  },
  mounted () {
    core.index()
  },
  data () {
    return {
      rows: [],
      circulateNotices: ''
    }
  },
  computed: {
    columns () {
      if (this.$i18n.locale === 'bn') {
        return [
          { key: this.$t('org_pro.organization'), val: this.circulateNotices.org_name_bn },
          { key: this.$t('notification.notice_titlel'), val: this.circulateNotices.notice_title_bn },
          { key: this.$t('notification.notice_descriptionl'), val: this.circulateNotices.description_bn },
          { key: this.$t('org_pro.office_namel'), val: (this.circulateNotices.office_name_bn) },
          { key: this.$t('globalTrans.designation'), val: (this.circulateNotices.designation_bn) },
          { key: this.$t('globalTrans.date'), val: (this.circulateNotices.notice_date) },
          { key: this.$t('globalTrans.time'), val: (this.circulateNotices.notice_time) }
        ]
      } else {
          return [
            { key: this.$t('org_pro.organization'), val: this.circulateNotices.org_name },
            { key: this.$t('notification.notice_titlel'), val: this.circulateNotices.notice_title },
            { key: this.$t('notification.notice_descriptionl'), val: this.circulateNotices.description },
            { key: this.$t('org_pro.office_namel'), val: (this.circulateNotices.office_name) },
            { key: this.$t('globalTrans.designation'), val: (this.circulateNotices.designation) },
            { key: this.$t('globalTrans.date'), val: (this.circulateNotices.notice_date) },
            { key: this.$t('globalTrans.time'), val: (this.circulateNotices.notice_time) }
          ]
      }
    },
    local () {
      return this.$i18n.locale
    }
  },
  watch: {},
  methods: {
    default () {
      return {
        id: this.rows.length,
        description: '',
        description_bn: '',
        org_id: '',
        org_name: '',
        editable: false
      }
    }
  }
}
</script>

<style scoped>
[dir=ltr][mode=light] .table thead th {
    display: none;
}
</style>
